module.exports = __webpack_public_path__ + "img/hsbc.3e84bcaa.png";